module.exports = __webpack_public_path__ + "static/media/share-light.56c24ae0.png";